import React, { useState } from "react";
import ReportTable from "../Components/Admin/ReportTable";
import Header from "../Components/Common/Header";
import "../Styles/Admin/ReportPage.css";
import { 
  FileText, 
  Search, 
  Calendar, 
  RefreshCw,
  Download,
  X
} from "lucide-react";

const ReportPage = () => {
  const today = new Date();
  const tomorrow = new Date(today);

  const formatDate = (date) => date.toISOString().split("T")[0]; 

  const [filters, setFilters] = useState({
    search: "",
    startDate: formatDate(today),
    endDate: formatDate(tomorrow),
  });
  
  const [appliedFilters, setAppliedFilters] = useState({...filters});
  const [isGenerating, setIsGenerating] = useState(false);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleGenerateReport = async () => {
    try {
      setIsGenerating(true);
      setAppliedFilters({ ...filters });
    } finally {
      setIsGenerating(false);
    }
  };

  const handleClear = () => {
    const defaultFilters = {
      search: "",
      startDate: formatDate(today),
      endDate: formatDate(tomorrow),
    };
    
    setFilters(defaultFilters);
    setAppliedFilters(defaultFilters);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleGenerateReport();
    }
  };

  return (
    <div className="rp-container">
      <div className="ap-wrap-content">
      <Header title={"Reports Dashboard"} description={"Generate and view attendance reports"} icon={<FileText size={28} color="#f3f4f6" />} />
      <div className="rp-content">
      </div>
      
        {/* Main Filters Bar */}
        <div className="rp-filters-card">
          <div className="rp-filters-row">
            <div className="rp-search-container">
              <Search className="rp-search-icon" size={18} />
              <input
                type="text"
                name="search"
                placeholder="Search by name or email"
                value={filters.search}
                onChange={handleFilterChange}
                onKeyPress={handleKeyPress}
                className="rp-search-input"
              />
            </div>
            
            <div className="rp-date-filters">
              <div className="rp-date-input-container">
                <Calendar size={16} className="rp-date-icon" />
                <input
                  type="date"
                  name="startDate"
                  value={filters.startDate}
                  onChange={handleFilterChange}
                  className="rp-date-input"
                />
              </div>
              
              <span className="rp-date-separator">to</span>
              
              <div className="rp-date-input-container">
                <Calendar size={16} className="rp-date-icon" />
                <input
                  type="date"
                  name="endDate"
                  value={filters.endDate}
                  onChange={handleFilterChange}
                  className="rp-date-input"
                />
              </div>
            </div>
          </div>
          
          <div className="rp-actions">
            <button 
              className="rp-generate-btn" 
              onClick={handleGenerateReport}
              disabled={isGenerating}
            >
              {isGenerating ? (
                <>
                  <RefreshCw size={16} className="rp-spinner" />
                  <span>Generating...</span>
                </>
              ) : (
                <>
                  <Download size={16} />
                  <span>Generate Report</span>
                </>
              )}
            </button>
            
            <button 
              className="rp-clear-btn" 
              onClick={handleClear}
            >
              <X size={16} />
              <span>Clear</span>
            </button>
          </div>
        </div>
        
        {/* Report Table Section */}
        <div className="rp-table-section">
          <ReportTable filters={appliedFilters} />
        </div>
      </div>
    </div>
  );
};

export default ReportPage;
